// TO DO: update colors once the design is finalize
const colors = {
    dark: {
        50: { value: '#FAFAFA' },
        100: { value: '#202020' },
        600: { value: '#3C3C3B' },
        700: { value: '#2B2B2A' },
        800: { value: '#1C1C1E' },
        900: { value: '#0d0d0d' },
    },
    blue: {
        200: { value: '#476FB5' },
        300: { value: '#4E88CD' },
        400: { value: '#178595' },
        500: { value: '#1ca8c0' },
        600: { value: '#244ea2' },
        700: { value: '#26509F' },
        800: { value: '#29b6aa' },
        900: { value: '#263b6e' },
    },

    gray: {
        50: { value: '#EEEEEE' },
        100: { value: '#F2F1F0' },
        200: { value: '#D1D1D6' },
        250: { value: '#D8D7D5' },
        300: { value: '#C7C7CC' },
        400: { value: '#A9A9A8' },
        450: { value: '#878379' },
        500: { value: '#959595' },
        600: { value: '#7D7D7C' },
        700: { value: '#48484A' },
        750: { value: '#464646' },
        800: { value: '#8a8a8e' },
    },
    green: {
        500: { value: '#6FB14C' },
    },
    secondary: {
        50: { value: '#FFFCEA' },
        100: { value: '#FEF7E5' },
        200: { value: '#F9F2F0' },
        300: { value: '#F3EDDA' },
        400: { value: '#D2CBBA' },
        500: { value: '#B4AE9D' },
        600: { value: '#898473' },
        700: { value: '#746F5F' },
        800: { value: '#544f40' }, // default
        850: { value: '#6A6A6A' },
        900: { value: '#312D1F' },
    },

    surface: {
        default: { value: '#EFEFED' },
        light: { value: '#FAFAF8' },
        medium: { value: '#D5D1CE' },
        dark: { value: '#BEBEBD' },
    },

    accent: {
        50: { value: '#F8EAE8' },
        100: { value: '#FACEC0' },
        200: { value: '#F7B098' },
        300: { value: '#F5916F' },
        400: { value: '#F47B4F' },
        500: { value: '#F36633' }, // default
        600: { value: '#E8602F' },
        700: { value: '#DA592B' },
        800: { value: '#CC5328' },
        900: { value: '#B24722' },
        1000: { value: '#662913' },
    },

    tertiaryGreen: {
        50: { value: '#E6F5E4' },
        100: { value: '#C3E5BE' },
        200: { value: '#9BD949' },
        300: { value: '#71C468' },
        400: { value: '#4FB746' },
        500: { value: '#26AA1C' },
        600: { value: '#1A9C12' },
        700: { value: '#008A00' }, // default
        800: { value: '#007900' },
        900: { value: '#005B00' },
    },

    tertiaryBlue: {
        50: { value: '#E9EBF4' },
        100: { value: '#C8CDE3' },
        200: { value: '#A4ACD1' },
        300: { value: '#828CBD' },
        400: { value: '#6872AF' },
        500: { value: '#4F5AA3' },
        600: { value: '#495299' },
        700: { value: '#40488D' }, // default
        800: { value: '#393E80' },
        900: { value: '#2D2D69' },
    },

    tertiaryMagenta: {
        50: { value: '#FCE5F2' },
        100: { value: '#F9BEDE' },
        200: { value: '#F894C8' },
        300: { value: '#F967B1' },
        400: { value: '#F9429D' },
        500: { value: '#FC0E88' },
        600: { value: '#EA1083' },
        700: { value: '#D2117C' }, // default
        800: { value: '#BC1077' },
        900: { value: '#950E6D' },
    },

    status: {
        success: { value: '#008748' },
        error: { value: '#E40030' },
        errorLight: { value: '#FCE5EA' },
        warning: { value: '#FFB800' },
        info: { value: '#544F40' },
        highlight: { value: '#a53208' },
        highlight_dark: { value: '#F56633' },
    },
    pink: {
        50: { value: '#EFEFED' },
    },
    red: {
        50: { value: '#FEF5F7' },
        100: { value: '#FFECEB' },
        800: { value: '#2d0a12' },
    },
    yellow: {
        25: { value: '#FFFAEB' },
        50: { value: '#FCFBE5' },
        100: { value: '#E49B13' },
        500: { value: '#F2AE00' },
    },
    widgets: {
        my_hosting: {
            light: { value: '#d74439' },
            dark: { value: '#ec7869' },
        },
        service_now: {
            light: { value: '#6fb04c' },
            dark: { value: '#a7d092' },
        },
        service_now_changes: {
            light: { value: '#6fb04c' },
            dark: { value: '#a7d092' },
        },
        scheduled_change_requests: {
            light: { value: '#6fb04c' },
            dark: { value: '#a7d092' },
        },
        sail_point: {
            light: { value: '#dc2361' },
            dark: { value: '#ef489a' },
        },
        sharepoint: {
            light: { value: '#26509f' },
            dark: { value: '#4e88cd' },
        },
        sail_point_cert: {
            light: { value: '#26509f' },
            dark: { value: '#4e88cd' },
        },
        sail_point_cert_decision: {
            light: { value: '#26509f' },
            dark: { value: '#4e88cd' },
        },
        my_learning: {
            light: { value: '#d74439' },
            dark: { value: '#ec7869' },
        },
        my_learning_ro: {
            light: { value: '#d74439' },
            dark: { value: '#ec7869' },
        },
        grp: {
            light: { value: '#50338e' },
            dark: { value: '#8465c7' },
        },
        workday_leave_requests: {
            light: { value: '#29b6aa' },
            dark: { value: '#54d8cd' },
        },
        workday_leave_tasks: {
            light: { value: '#29b6aa' },
            dark: { value: '#54d8cd' },
        },
        sap_grc_access_request: {
            light: { value: '#263b6e' },
            dark: { value: '#4064ba' },
        },
        sap_leave_request: {
            light: { value: '#263b6e' },
            dark: { value: '#4064ba' },
        },
        fieldglass_timesheet: {
            light: { value: '#B28F2E' },
            dark: { value: '#F2C444' },
        },
        fieldglass_complementary_worker: {
            light: { value: '#2EB0CA' },
            dark: { value: '#57CDE4' },
        },
        tne: {
            light: { value: '#336E13' },
            dark: { value: '#589B35' },
        },
    },
}

export default colors
